import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link, SmartInput } from '@beef/legacy-ui-kit';
import { CAPTCHA_STATUS } from "../../../../../../../hoc/CaptchaWithCallbackPopupHOC";
import { requestCaptcha } from "./services";
import styles from "./Captcha.pcss";
var cx = classNames.bind(styles);
var DEFAULT_CAPTCHA_WIDTH = 148;
var DEFAULT_CAPTCHA_HEIGHT = 39;
var Captcha = /*#__PURE__*/function (_Component) {
  function Captcha(props) {
    var _this;
    _classCallCheck(this, Captcha);
    _this = _callSuper(this, Captcha, [props]);
    _defineProperty(_this, "handleChange", function (value) {
      var onChange = _this.props.onChange;
      _this.setValue(value);
      onChange === null || onChange === void 0 || onChange(value);
    });
    _this.state = {
      pic: null,
      captcha: '',
      captchaKey: ''
    };
    _this.fetchCaptcha = _this.fetchCaptcha.bind(_this);
    _this.setValue = _this.setValue.bind(_this);
    return _this;
  }
  _inherits(Captcha, _Component);
  return _createClass(Captcha, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;
      this.fetchCaptcha();
      onMount === null || onMount === void 0 || onMount(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
        newCaptcha = _this$props.newCaptcha,
        changeNewCaptcha = _this$props.changeNewCaptcha;
      if (newCaptcha) {
        this.fetchCaptcha();
        this.setValue('');
        // eslint-disable-next-line sonarjs/no-gratuitous-expressions
        changeNewCaptcha(!newCaptcha);
      }
    }
  }, {
    key: "setValue",
    value: function setValue(captcha) {
      this.setState({
        captcha: captcha
      });
    }
  }, {
    key: "fetchCaptcha",
    value: function fetchCaptcha() {
      var _this2 = this;
      var _this$props2 = this.props,
        width = _this$props2.width,
        height = _this$props2.height,
        setCaptchaKey = _this$props2.setCaptchaKey,
        changeCaptchaMsg = _this$props2.changeCaptchaMsg,
        changeCaptchaStatus = _this$props2.changeCaptchaStatus,
        changeCaptchaToken = _this$props2.changeCaptchaToken;
      var captchaKey = this.state.captchaKey;
      var params = new URLSearchParams(_objectSpread(_objectSpread({
        w: width,
        h: height
      }, captchaKey ? {
        key: captchaKey
      } : {}), {}, {
        r: new Date().getTime()
      })).toString();
      requestCaptcha("/captcha.ashx?".concat(params)).then(function (_ref) {
        var pic = _ref.pic,
          key = _ref.key;
        if (!captchaKey && key) {
          setCaptchaKey(key);
        }
        _this2.setState({
          pic: pic,
          captchaKey: key
        });
      }).catch(console.error);
      this.setValue('');
      changeCaptchaMsg('');
      changeCaptchaToken('');
      changeCaptchaStatus(CAPTCHA_STATUS.success);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        name = _this$props3.name,
        onBlur = _this$props3.onBlur,
        onFocus = _this$props3.onFocus,
        status = _this$props3.status,
        msg = _this$props3.msg,
        inputId = _this$props3.inputId,
        errorMsg = _this$props3.errorMsg;
      var _this$state = this.state,
        pic = _this$state.pic,
        captcha = _this$state.captcha;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('captcha'),
        "data-t-id": "components-Captcha"
      }, /*#__PURE__*/React.createElement("span", null, msg.title), /*#__PURE__*/React.createElement(SmartInput, {
        captcha: pic,
        className: cx('captchaInput'),
        inputId: inputId,
        mask: "_____",
        msg: errorMsg,
        name: name,
        onBlur: onBlur,
        onChange: this.handleChange,
        onFocus: onFocus,
        status: status,
        value: captcha
      }), /*#__PURE__*/React.createElement("div", {
        className: cx('reset')
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: this.fetchCaptcha
      }, msg.reloadText)));
    }
  }]);
}(Component);
Captcha.defaultProps = {
  width: DEFAULT_CAPTCHA_WIDTH,
  height: DEFAULT_CAPTCHA_HEIGHT
};
Captcha.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  changeCaptchaToken: PropTypes.func,
  status: PropTypes.string,
  changeCaptchaStatus: PropTypes.func,
  msg: PropTypes.shape({
    title: PropTypes.string,
    reloadText: PropTypes.string
  }),
  setCaptchaKey: PropTypes.func,
  onMount: PropTypes.func,
  inputId: PropTypes.string,
  onChange: PropTypes.func,
  errorMsg: PropTypes.string,
  changeCaptchaMsg: PropTypes.func,
  newCaptcha: PropTypes.bool,
  changeNewCaptcha: PropTypes.func
} : {};
export default Captcha;